import { Button } from "react-bootstrap";
import SuggestedFollows from "../reusable-comps/SuggestedFollows";
import Timeline from "../reusable-comps/Timeline";
import CustomerHero from "../components/CustomerHero";
import ConnectWritePost from "../components/ConnectWritePost";
import ConnectSideMenu from "../components/ConnectSideMenu";
import { List } from "react-bootstrap-icons";
import { advertContent } from "../advertContent";
import AdvertBox from "../reusable-comps/AdvertBox";
import useConnect from "../hooks/useConnect";
import EmptyState from "../components/reusable/EmptyState";
import { ChatDotsFill } from "react-bootstrap-icons";

const Connect = ({ user }) => {
  const {
    token,
    businessInfo,
    displayName,
    following,
    followers,
    categories,
    suggestedFollows,
    sortedPosts,
    sortNewest,
    toggleSort,
    showMenu,
    setShowMenu,
    refetch,
  } = useConnect(user);

  return (
    <div className="page-container" style={{ paddingTop: "80px" }}>
      <div className="connect-layout">
        {/* Left Sidebar - Profile */}
        <aside id="customer-hero" className="d-none d-lg-block">
          <div style={{ position: "sticky", top: "80px" }}>
            <CustomerHero
              businessName={displayName}
              category={businessInfo?.category}
              followers={followers[0]?.length ?? 0}
              following={following[0]?.length ?? 0}
              businessCategories={categories}
            />
          </div>
        </aside>

        {/* Mobile menu trigger */}
        <div id="show-side-menu" className="d-lg-none d-none mb-3">
          <Button
            className="btn-ghost d-flex align-items-center gap-2"
            onClick={() => setShowMenu(true)}
          >
            <List /> Menu
          </Button>
        </div>

        {/* Center - Feed */}
        <main className="feed-container w-100">
          <ConnectWritePost
            user={user}
            authorName={businessInfo?.businessName}
            refetch={refetch}
          />

          <div className="d-flex justify-content-between align-items-center mb-3 px-1">
            <h2
              className="mb-0 fw-bold"
              style={{ fontSize: "20px", color: "var(--text-primary)" }}
            >
              Your Feed
            </h2>
            <button
              className="btn-ghost px-3 py-1"
              onClick={toggleSort}
              style={{ fontSize: "13px" }}
            >
              {sortNewest ? "Newest first" : "Oldest first"}
            </button>
          </div>

          <div className="d-flex flex-column gap-0">
            {sortedPosts.length > 0 ? (
              sortedPosts.map((element, i) => (
                <Timeline
                  refetch={refetch}
                  key={element._id ?? i}
                  contentBody={element?.contentBody}
                  contentImage={element?.contentImage}
                  likes={element?.likes}
                  id={element._id}
                  bookmarks={element?.isBookmarked}
                  authorName={element?.authorName}
                  authorEmail={element?.authorEmail}
                  authorImage={element?.authorImage}
                  businessCategory={element?.category}
                  user={user}
                  token={token}
                  secondParty={element.authorEmail}
                  isEdited={element.isEdited}
                />
              ))
            ) : (
              <EmptyState
                icon={ChatDotsFill}
                title="No posts yet"
                description="Follow other members or write your first post!"
              />
            )}
          </div>
        </main>

        {/* Right Sidebar */}
        <aside className="sidebar-right d-none d-lg-block">
          <div style={{ position: "sticky", top: "80px" }}>
            {/* Suggestions */}
            {suggestedFollows.length > 0 && (
              <div className="sidebar-card">
                <div className="sidebar-card-header">People you may know</div>
                <div className="sidebar-card-body">
                  {suggestedFollows.map((item, i) => (
                    <SuggestedFollows
                      key={i}
                      user={user}
                      businessName={item?.businessName}
                      category={item.category}
                      secondParty={item.clientUID}
                      secondPartyEmail={item.userEmail}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Sponsored */}
            <div className="sidebar-card">
              <div className="ad-label d-flex align-items-center gap-1">
                Sponsored
                <span
                  title="Sponsored content from our partners"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    fontSize: "11px",
                    background: "var(--bg-hover)",
                    color: "var(--text-tertiary)",
                    cursor: "help",
                  }}
                >
                  ?
                </span>
              </div>
              <div className="sidebar-card-body p-3 d-flex flex-column gap-3">
                {advertContent.map((el, index) => (
                  <AdvertBox
                    key={index}
                    title={el.title}
                    content={el.content}
                    image={el.image}
                  />
                ))}
              </div>
            </div>
          </div>
        </aside>
      </div>

      {/* Mobile Side Menu */}
      {showMenu && (
        <ConnectSideMenu
          show={showMenu}
          setShow={setShowMenu}
        >
          <CustomerHero
            businessName={displayName}
            category={businessInfo?.category}
            followers={followers[0]?.length ?? 0}
            following={following[0]?.length ?? 0}
            businessCategories={categories}
          />
        </ConnectSideMenu>
      )}
    </div>
  );
};

export default Connect;
